import React from 'react'
import { useSelector } from 'react-redux'

import { AlertWithActions, AlertWithActionsType } from '@masfront/common-b2c'

import { Box, Typography, Collapse } from '@material-ui/core'

import { BundleType } from '../../model/bundles.model'
import { selectHasSelectedBundles } from '../../store/bundles.selectors'
import SelectedBundles from '../SelectedBundles/SelectedBundles'

import { RootState } from '~/core/store/root.reducer'
import DisplayPrices from '~/prices/components/DisplayPrices'
import { selectBundlesAndTariffPrice } from '~/prices/prices.selectors'
import {
  selectTariffPermanentDiscounts,
  selectHasPermanentDiscounts,
} from '~/tariff/store/tariff.selectors'

export default function BundlesSummary({ id }: { id: string }) {
  const hasSelectedBundles = useSelector((state: RootState) => selectHasSelectedBundles(state, id))
  const formattedBundleAndTariffPrice = useSelector((state: RootState) =>
    selectBundlesAndTariffPrice(state, id),
  )
  const permanentDiscounts = useSelector((state: RootState) =>
    selectTariffPermanentDiscounts(state, id),
  )
  const hasPermanentDiscounts = useSelector((state: RootState) =>
    selectHasPermanentDiscounts(state, id),
  )

  return (
    <>
      <Collapse in={hasPermanentDiscounts}>
        <Box px={6} pb={6}>
          <Box pb={4}>
            <Typography variant="subtitle2">DESCUENTO APLICADO POR TARIFA</Typography>
          </Box>
          {permanentDiscounts.map((discount) => (
            <AlertWithActions type={AlertWithActionsType.info}>
              <Box display="flex">
                <Box pr={3}>
                  <Typography variant="body1">Descuento incluido en la tarifa:</Typography>
                </Box>
                <Box pr={3}>
                  <Typography variant="body1">{discount?.displayAmount}</Typography>
                </Box>
              </Box>
            </AlertWithActions>
          ))}
        </Box>
      </Collapse>
      <Collapse in={hasSelectedBundles}>
        <Box px={6}>
          <Box pb={4}>
            <Typography variant="subtitle2">OPCIONES AÑADIDAS</Typography>
          </Box>
          <SelectedBundles id={id} dataHook="applied-bundles" type={BundleType.PROMOS} />
          <SelectedBundles id={id} dataHook="applied-bundles" type={BundleType.BONUS} />
          <Box display="flex" alignItems="center" pt={3} pb={4}>
            <Box pr={1}>
              <Typography color="textSecondary" variant="body2">
                Precio resultante:
              </Typography>
            </Box>
            <Box>
              <DisplayPrices prices={formattedBundleAndTariffPrice} />
            </Box>
          </Box>
        </Box>
      </Collapse>
    </>
  )
}
